<template>
  <SkeletonRoot
    v-for="(_, index) in 12"
    :delay="Math.floor(index / (deviceType === 'MOBILE' ? 2 : 6))"
  >
    <Skeleton
      aspect-ratio="1"
    />
    <div :style="{ marginTop: '8px', paddingLeft: '4px' }">
      <Skeleton width="80px" />
      <Skeleton height="16px" />
      <Skeleton width="80px" />
      <Skeleton
        :style="{ marginTop: '12px' }"
        height="16px"
      />
      <Skeleton width="80px" />
    </div>
  </SkeletonRoot>
</template>

<script setup>
import { SkeletonRoot, Skeleton } from '@/components/Skeleton'
import { useDevice } from '@/hooks/useDevice'

const { deviceType } = useDevice()
</script>

<style lang="less">
  @import './index.less';
</style>
